<template lang="pug">
.page
  WechatMPCardV1(v-if="version===1")
  WechatMPCardV2(v-if="version===2")
</template>

<script>
import WechatMPCardV1 from '../wechat-mp-card/index.vue';
import WechatMPCardV2 from '../wechat-mp-card-new/index.vue';
import { UBTUtils } from '../../utils/ubt';
import { ENTER_TYPE } from '../wechat-mp-card-new/const';

export default {
  components: {
    WechatMPCardV1,
    WechatMPCardV2,
  },
  data() {
    return {
      version: null,
    };
  },
  created() {
    this.version = Number(this.$route.query.version) || 1;
    this.pv();
  },
  methods: {
    pv() {
      if (this.version === 1) {
        const { gray } = this.$route.query;
        if (gray) {
          UBTUtils.pageView({
            pageId: 'newebike_H5wechat',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBTUtils.pageView({
            pageId: 'ebike_wechatH5',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
      } else if (this.version === 2) {
        const ENTER_TYPES = ENTER_TYPE();
        const curEnterType = Number(this.$route.query.enterType);
        UBTUtils.moduleExpose({
          pageId: 'ptzlc_detainew',
          categoryId: 'platform',
          moduleId: 'ptzlc_expose_detail',
          contentId: 'ptzlc_expose_detail',
          exposureTimes: 1,
          businessInfo: {
            enterType: curEnterType,
          },
        });
        if (ENTER_TYPES.wechat === curEnterType) {
          UBTUtils.pageView({
            pageId: 'wxkl_zlc_wxsys',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else if (ENTER_TYPES.platform === curEnterType) {
          UBTUtils.pageView({
            pageId: 'wxkl_zlc_ptsys',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBTUtils.pageView({
            pageId: 'wxkl_zlc_wxsys',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
      }
    },
  },
};
</script>
